var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-pdf-app',{class:Object.keys(_vm.userData).length > 0 ? 'alturaPdf' : 'alturaPdfGuest',attrs:{"pdf":_vm.arquivoPdf,"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }